/** Default tab title — keep in sync with `index.html` `<title>`. */
export const DEFAULT_DOCUMENT_TITLE = "Institute Portal";

/** Tab title when the WordPress embed query is present (`?source=wp`). */
export const WP_EMBED_DOCUMENT_TITLE = "Authorized Portal";
